module.exports = __webpack_public_path__ + "static/awards-bottom-reviews-d4442fc23ebe500270a5828bee3ffa02.gif";